import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Overlay} from '@shared/overlay/overlay';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {

  private readonly subject = new BehaviorSubject<Overlay | null>(null);

  public overlay$ = this.subject.asObservable();

  public show(overlay: Overlay): void {
    if (!overlay.level) {
      overlay.level = 'info';
    }
    this.subject.next(overlay);
  }

  public hide(): void {
    this.subject.next(null);
  }

}
